module.exports = __webpack_public_path__ + "f5c885d9608477a8c4e7f02f0f47a6f4.jpg";